import { createTheme } from "@mui/material";

const theme = createTheme({
    typography: {
        fontFamily: ["DM Sans", "Noto Sans Thai"].join(",")
    },
    palette: {
        greyBackground: {
            main: "#f2f6f8",
            dark: "#e0e0e0",
            contrastText: "#000000"
        },
        default: {
            main: "#eaeaea",
            dark: "#ffffff",
            contrastText: "#000000"
        },
        table: {
            main: "#f8fafc",
            dark: "#ffffff",
            contrastText: "#000000"
        },
        primary: {
            light: "#E1F8F5",
            main: "#05AA97",
            contrastText: "#ffffff"
        },
        secondary: {
            main: "#06314d",
            contrastText: "#ffffff"
        },
        info: {
            main: "#185abd",
            contrastText: "#ffffff"
        },
        success: {
            main: "#14CCA3"
        },
        error: {
            main: "#D7625D",
            contrastText: "#ffffff"
        },
        warning: {
            main: "#F2A068",
            contrastText: "#ffffff"
        },
        highlightOrange: {
            main: "#FFBA94",
            contrastText: "#000000"
        },
        highlightRed: {
            main: "#FF9494",
            contrastText: "#000000"
        },
        lightGreen: {
            main: "#E7FFF7",
            dark: "#E7FFF7",
            light: "#E7FFF7",
            contrastText: "#06314C"
        }
    },
    components: {
        MuiTextField: {
            defaultProps: {
                size: "small",
                variant: "outlined"
            }
        },
        MuiButton: {
            defaultProps: {
                variant: "contained",
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    borderRadius: "6px"
                }
            }
        }
    }
});

declare module "@mui/material/styles" {
    interface Palette {
        greyBackground: Palette["primary"];
        lightGreen: Palette["primary"];
        default: Palette["primary"];
        table: Palette["primary"];
    }
    interface PaletteOptions {
        greyBackground: PaletteOptions["secondary"];
        lightGreen: Palette["secondary"];
        default: PaletteOptions["secondary"];
        table: PaletteOptions["secondary"];
    }
    interface Palette {
        highlightRed: Palette["primary"];
        lightGreen: Palette["primary"];

        default: Palette["primary"];
        table: Palette["primary"];
    }
    interface PaletteOptions {
        highlightRed: PaletteOptions["secondary"];
        lightGreen: Palette["secondary"];

        default: PaletteOptions["secondary"];
        table: PaletteOptions["secondary"];
    }
    interface Palette {
        highlightOrange: Palette["primary"];
        lightGreen: Palette["primary"];

        default: Palette["primary"];
        table: Palette["primary"];
    }
    interface PaletteOptions {
        highlightOrange: PaletteOptions["secondary"];
        lightGreen: Palette["secondary"];

        default: PaletteOptions["secondary"];
        table: PaletteOptions["secondary"];
    }
}

declare module "@mui/material/Button" {
    interface ButtonPropsColorOverrides {
        default: true;
    }
}

export default theme;
